import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Label from './label';

const Field = ({ children, help, label, required, inline }) => (
  <Container className="field-container">
    <span className="inline-label">
      <Label required={required}>{label}</Label>
    </span>

    <div className="child">
      {children && cloneElement(children, { required })}
    </div>

    <div className="help">{help || ''}</div>
  </Container>
);

Field.propTypes = {
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  inline: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool,
};

Field.defaultProps = {
  help: '',
  inline: false,
  label: '',
  required: false,
};

const Container = styled.div`
  color: ${props => props.theme.subText};
  font-family: ${props => props.theme.baseFontFamily};
  font-size: ${props => props.theme.formFontSize};
  margin-bottom: ${props => props.theme.superViewSpacing}px;
  overflow: visible;
  position: relative;
  width: 100%;

  .child {
    margin-top: ${props => props.theme.siblingSpacing}px;
  }

  ${props => {
    if (props.inline) {
      return `
        display: flex;
        align-items: center;
        width: 85%;

        .line-label {
          width: 15%;
          margin-top: 0px;
        }

        .child {
          width: 85%;
          margin-top: 0px;
        }
      `;
    }
  }}

  .help {
    font-size: 0.65em;
    margin-top: ${props => props.theme.siblingSpacing}px;
  }
`;

export default Field;
